import React from 'react'
import { ArrowDownTrayIcon } from '@heroicons/react/24/solid'

const DownloadImportBtn = () => {
    const handleDownload = () => {
        const filePath = `${process.env.PUBLIC_URL}/scraperdata-import-template.ods`;

        const link = document.createElement('a');
        link.href = filePath;
        link.download = 'scraperdata-import-template.ods';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return (
        <button
            type="button"
            onClick={handleDownload}
            className="inline-flex items-center gap-1.5 text-xs font-medium text-signal hover:underline"
        >
            <ArrowDownTrayIcon className="h-4 w-4" />
            Download template
        </button>
    )
}

export default DownloadImportBtn
